module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('input', {
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "exampleInputEmail1",
      "aria-describedby": "emailHelp",
      "placeholder": "Enter email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }, 'input', _vm.email, false)), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "emailHelp"
    }
  }, [_vm._v("We'll never share your email with anyone else.")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "exampleInputPassword1"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "v-model": _vm.password,
      "id": "exampleInputPassword1",
      "placeholder": "Password"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.storeInfo
    }
  }, [_vm._v("Submit")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-013ee0ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 827
// module chunks = 0